module.exports = __webpack_public_path__ + "static/virus-sms-ae14172f4ce5f79db86adc474edfbd81.webm";